const handlePostHeader = () => {
  const headerImg = document.querySelector(
    '.news-item-detail [itemprop="image"] meta[itemprop="url"]'
  );
  if (!headerImg) return;
  const postHeader = document.createElement("div");
  postHeader.classList.add("post-header", "container");
  postHeader.style.backgroundImage = `url(${headerImg.content})`;
  const contentWrapper = document.querySelector("#content-wrapper");
  contentWrapper.parentElement.insertBefore(postHeader, contentWrapper);
};
const handlePostSidebar = async () => {
  const postContent = document.querySelector(".news-item-detail");
  if (!postContent) return;
  const sidebar = document.createElement("aside");
  sidebar.classList.add("sidebar", "sidebar--post");
  postContent.parentElement.appendChild(sidebar);

  const parentFetch = await fetch("/blog/");
  const parentText = await parentFetch.text();
  const parser = new DOMParser();
  const parentDoc = parser.parseFromString(parentText, "text/html");
  const categories = parentDoc.querySelector(".subcategories");
  if (categories) {
    const subcategoriesBlock = document.createElement("div");
    subcategoriesBlock.classList.add("subcategories--block");
    const subcategoriesTitle = document.createElement("h2");
    subcategoriesTitle.textContent = "Další rubriky";
    subcategoriesBlock.appendChild(subcategoriesTitle);
    subcategoriesBlock.appendChild(categories);
    sidebar.appendChild(subcategoriesBlock);
  }

  const newsletter = document.querySelector(".custom-footer__newsletter");
  if (newsletter) {
    const newsletterClone = newsletter.cloneNode(true);
    sidebar.appendChild(newsletterClone);
    const newsletterTitle = newsletterClone.querySelector("h4");
    if (newsletterTitle) {
      newsletterTitle.textContent = "Odebírejte novinky";
    }
  }
};

const handlePostGallery = () => {
  const galleries = document.querySelectorAll(
    ".news-item-detail .plus-gallery-wrap"
  );
  if (!galleries.length || window.innerWidth > 767) return;
  for (let i = 0; i < galleries.length; i++) {
    const gallery = galleries[i];
    $(gallery).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      infinite: false,
    });
  }
};

const handleBlogReadMore = () => {
  const newsItems = document.querySelectorAll("#newsWrapper .news-item");
  newsItems.forEach((item) => {
    if (item.querySelector(".read-article")) return;
    const textEl = item.querySelector(".text");
    if (!textEl) return;
    const href =
      item.querySelector(".title a")?.href ||
      item.querySelector(".image a")?.href ||
      item.querySelector("a")?.href;
    const btn = document.createElement("a");
    btn.className = "read-article";
    if (href) btn.href = href;
    btn.innerHTML = `Přečíst článek <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    textEl.appendChild(btn);
  });
};

const handleDmProductsPosition = () => {
  const move = () => {
    const anchor = document.querySelector(".news-item-detail");
    if (!anchor) return;
    const dm = document.querySelector(".dmproducts");
    if (!dm) return;
    if (anchor.nextElementSibling === dm) return;
    anchor.after(dm);
  };

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (
          node.classList?.contains("dmproducts") ||
          node.querySelector?.(".dmproducts")
        ) {
          move();
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  move();
};

export { handlePostHeader, handlePostSidebar, handlePostGallery, handleBlogReadMore, handleDmProductsPosition };
